export default "__VITE_ASSET__YKN7E17R__"